export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["MEMBER"] = "MEMBER";
    UserRole["VIEWER"] = "VIEWER";
    UserRole["CREATOR"] = "CREATOR";
})(UserRole || (UserRole = {}));
/**
 * Applications that may be granted access to a user account. The
 * `X-Application` header + the JWT `app` claim plus the explicit
 * `user_applications` allowlist row are what gate application-level access
 * (e.g. the DEVICE_FARM dashboard vs the standalone CONTENT_UPLOADER app).
 */
export var Application;
(function (Application) {
    Application["DEVICE_FARM"] = "DEVICE_FARM";
    Application["CONTENT_UPLOADER"] = "CONTENT_UPLOADER";
})(Application || (Application = {}));
//# sourceMappingURL=auth.types.js.map